
<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardContent
        :cardContent="content"
        :cardTypeProps="cardTypeProps"
        @nextRoute="nextRoute"
        :soundOBJ="soundObject"
      />
    </template>
  </div>
</template>
<script>
import CardContent from "../../components/template/Chinese1/CardContent";
import CardPopupImg from "../../components/template/Chinese1/CardPopupImg";
import { mapGetters } from "vuex";
import "../../assets/scss/_chineseStyle.scss";
import LoadingMDL from "../../components/loading/LoadingMDL";


export default {
  components: { CardContent, CardPopupImg, LoadingMDL },
  name: "CTA05",
  data() {
    return {
      cardTypeProps: true,
      content: {},
      lang: this.$store.getters["language/getLanguage"],
      baseURL: "CTA05-",
      CheckWidth: window.innerWidth.toString(),
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      soundObject: [],
      baseUrl: process.env.VUE_APP_URL_SOUND,
      courseSection: "",
      startTime: "",
      condition: [],
      courseId: "",
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      storeLanguage: "language/getLanguage",
      getUserTemplate: "template/getUserTemplate",
      loadingGetter: "template/loadingGetter",
    }),
  },

  watch: {
    allCourse: function (val) {
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.content = val;
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseId,
          template: val._id,
          section: this.courseSection,
        });
        var data = val.content.page[0].paragraph;
        for (let i = 0; i < data.length; i++) {
          this.soundObject.push(
            new Audio(this.baseUrl + data[i].line[0].class)
          );
        }
      }
    },
    storeLanguage: function (val) {
      this.lang = val;
    },
    getUserTemplate: function (val) {
      this.userTemplateData = val;
      this.condition = [
        {
          criteria: val.data.condition.criteriaType[0].criteria._id,
          val: val.data.condition.criteriaType[0].val,
        },
      ];
      this.loading = false;
    },
    loadingGetter: function (val) {
      if (val == true) {
        this.$router.push(this.nextAction);
      }
    },
  },

  mounted() {
    let body = {};
    body.code = this.courseId;
    body.templateCode = `CTA05-` + this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
  },

  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"].code;
    this.courseId = this.$store.getters["necessary/getLerningCourse"]._id;
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
  },

  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    nextRoute(path) {
      if (path.type == 0) {
        this.goBack(path.path);
      } else if (path.type == 1) {
        this.linkNextTo(path.path);
      }
    },
    linkNextTo(path) {
      let str = path.split("-");
      const useTime = this.$helpers.getUseTime();
      // this.userTemplateData.template = this.$helpers.setUserCriteria(
      //   this.userTemplateData.template,
      //   useTime
      // );
      // if (this.userTemplateData.quiz.length !== 0) {
      //   this.userTemplateData.quiz = this.$helpers.setUserQuizScore(
      //     this.userTemplateData.quiz,
      //     this.score
      //   );
      // }
      this.nextAction = "/" + str[0] + "/" + str[1];
      /*
      this.$store.dispatch(
        "template/saveUserTemplateData",
        this.userTemplateData
      );
      */
      this.$store.dispatch("template/saveUserTemplateData", {
        code: this.courseId,
        template: this.content._id,
        section: this.courseSection,
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
      });
      // this.$router.push("/" + str[0] + "/" + str[1]);
    },
    goBack(path) {
      let str = path.split("-");
      this.$router.push("/" + str[0] + "/" + str[1]);
    },
  },
};
</script>
<style>
</style>